<template>
  <Modal :id="id" title="Course Requests">
    <div slot="body" class="modal-body bg-light">
      <p>
        This form should be used to request the addition of a new distributor
        course to My Learning Center. This form is NOT used to schedule class
        dates.
      </p>
      <p>
        Would you like to proceed with adding a course to the course catalog?
      </p>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-primary mr-2" :href="route('course-request.create')"
        >Yes</a
      >
      <a class="btn btn-info" href="#" @click.prevent="close">No</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "course-request-notice-modal",
    };
  },
};
</script>